
import { NestedTranslations } from './types';
import { ptBR } from './pt-BR';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { it } from './it';

export const translations: Record<string, NestedTranslations> = {
  'pt-BR': ptBR,
  'en': en,
  'es': es,
  'fr': fr,
  'it': it
};
